export enum PriorityOneReviewType {
  Initial = 'Initial',
  Final = 'Final'
}
